var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeds(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.275H7.975V11.5H10.825V9.5H7.975V6.725H6V9.5H3.175V11.5H6V14.275ZM1.5 18C1.0875 18 0.734375 17.8531 0.440625 17.5594C0.146875 17.2656 0 16.9125 0 16.5V4.525C0 4.1125 0.146875 3.75938 0.440625 3.46563C0.734375 3.17188 1.0875 3.025 1.5 3.025H12.5C12.9125 3.025 13.2656 3.17188 13.5594 3.46563C13.8531 3.75938 14 4.1125 14 4.525V16.5C14 16.9125 13.8531 17.2656 13.5594 17.5594C13.2656 17.8531 12.9125 18 12.5 18H1.5ZM1.5 16.5H12.5V4.525H1.5V16.5ZM1 1.5V0H13.025V1.5H1Z",
    fill: "#A8A8AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeds);
export default __webpack_public_path__ + "static/media/meds.e0f041b140d797ced262ed29eb2b37c9.svg";
export { ForwardRef as ReactComponent };